import React from 'react';
import styled from 'styled-components';
import * as RDBCases from '../../services/buildfire/rdb/cases';
import InfoSection, { LineItem } from './caseInfo/InfoSection';
import moment from 'moment-timezone';
import { dueBy } from '../../util/case';

interface SubmitterInfoProps {
  case: Partial<RDBCases.Case> & {
    submitter: RDBCases.Case['submitter'];
  };
  clinicName: string;
  clinicEmail: string;
  isAdmin?: boolean;
  priorityInfo?: RDBCases.PriorityInfo;
}

const MailTo = styled.a`
  text-decoration: underline;
`;

const SubmitterInfo: React.FC<SubmitterInfoProps> = ({
  case: userCase,
  clinicName,
  clinicEmail,
  isAdmin,
  priorityInfo,
}) => {
  if (!userCase) {
    return null;
  }

  const hasSubmitterEmail =
    userCase.submitter.email && userCase.submitter.email !== clinicEmail;
  const submitterEmail = hasSubmitterEmail ? (
    isAdmin ? (
      <>
        {' '}
        (
        <MailTo href={`mailto:${userCase.submitter.email}`}>
          {userCase.submitter.email}
        </MailTo>
        )
      </>
    ) : (
      <> ({userCase.submitter.email})</>
    )
  ) : undefined;

  const dueByInfo = priorityInfo
    ? dueBy(
        priorityInfo.businessStart,
        priorityInfo.businessEnd,
        userCase.priority || false,
        userCase.createdAt || Date.now()
      )
    : undefined;

  return (
    <InfoSection title="Submitted by">
      <LineItem name="Clinic" description={clinicName} />
      <LineItem
        name="Email"
        description={
          isAdmin ? (
            <MailTo href={`mailto:${clinicEmail}`}>{clinicEmail}</MailTo>
          ) : (
            clinicEmail
          )
        }
      />
      <LineItem
        name="Veterinarian"
        description={
          <>
            {userCase.submitter.first} {userCase.submitter.last}
            {submitterEmail}
          </>
        }
      />
      <LineItem
        name="Submission time"
        description={
          moment
            .tz(userCase.createdAt, 'UTC')
            .tz(moment.tz.guess())
            .format('llll z') +
          (dueByInfo?.isAfterHours ? ' (after hours)' : '')
        }
      />
      {isAdmin && dueByInfo && (
        <LineItem
          name="Due by"
          description={
            dueByInfo.dueBy.tz(moment.tz.guess()).format('llll z') +
            ' (' +
            dueByInfo.dueBy.fromNow() +
            ')'
          }
        />
      )}
      {userCase.internalReferenceNumber && (
        <LineItem
          name="Reference number"
          description={userCase.internalReferenceNumber}
        />
      )}
    </InfoSection>
  );
};

export default SubmitterInfo;
